import { useSelector } from 'react-redux';

import { getCmsBlockById, getCurrentBlockId } from '../../../ducks';

export const useGetCurrentBlockData = () => {
  const currentBlock = useSelector(getCurrentBlockId);

  return useSelector(getCmsBlockById(currentBlock));
};
